<template>
  <transition name="fade">
    <div
      v-if="isOffline"
      class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40"
    >
      <div class="mx-4 w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <div class="mb-3 flex items-center gap-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            class="h-6 w-6 text-red-600"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h3 class="text-lg font-semibold text-gray-900">You’re offline</h3>
        </div>
        <p class="mb-4 text-sm text-gray-700">
          We lost the internet connection. Some actions may not work. We’ll reconnect automatically
          when you’re back online.
        </p>
        <div class="flex items-center justify-center">
          <button
            type="button"
            class="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50 mx-auto"
            :disabled="true"
          >
            Waiting for connection…
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { useNetworkStatus } from "@/composables/useNetworkStatus";

const { isOffline } = useNetworkStatus();
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
